module.exports = __webpack_public_path__ + "img/beneditoMobileLogo.367710c6.png";